import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Sentry as early as possible so it can capture render errors
// thrown anywhere in the tree, including initial hydration.
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Session replay only on errors — not full-session, to keep volume
      // and PII exposure minimal.
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    // Light tracing — 10% of transactions get performance data, plenty
    // to spot regressions without flooding the project quota.
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NODE_ENV,
    // v2.6 AD7: same release name as the server (the git SHA Railway builds).
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
  });
}

const app = (
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={({ error, resetError }) => (
      <div style={{ padding: '40px 24px', maxWidth: '520px', margin: '40px auto', fontFamily: 'inherit' }}>
        <div style={{ fontFamily: 'Georgia, serif', fontSize: '22px', fontWeight: '800', color: '#0D1117', marginBottom: '8px' }}>
          Something went wrong.
        </div>
        <div style={{ fontSize: '14px', color: '#5A6070', lineHeight: '1.6', marginBottom: '20px' }}>
          We've been notified and are looking into it. Try reloading the page — if it keeps happening, contact your coach or HoopHero support.
        </div>
        <button
          onClick={resetError}
          style={{ background: '#C2460B', color: '#fff', border: 'none', borderRadius: '8px', padding: '11px 22px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
        >
          Try again
        </button>
      </div>
    )}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// react-snap prerenders each public route to static HTML at build time.
// If that prerendered markup is present, hydrate it; otherwise (dev, or a
// route react-snap didn't cover) render from an empty root as usual.
const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

reportWebVitals();
